import React from "react";
import styles from "./CustomMaterials.module.css";
import { Link } from "react-router-dom";
import DesignShowcase from "../../components/designShowcase/DesignShowcase";
import LineAnimation from "../../components/lineAnimations/LineAnimation";
import LineAnimationTwo from "../../components/lineAnimationsTwo/LineAnimationTwo";
import FAQ from "../../components/faq/Faq";

const CustomMaterials = () => {
  return (
    <>
      <div className={styles.pageBck}>
        <LineAnimation />
        <LineAnimationTwo />
        <div className={styles.pageBanner}>
          <h1>Materiale të Personalizuara</h1>
          <span>CUSTOM MATERIALS</span>
          <p>
            Fletushka, Vizitkarta dhe Stickera të Dizajnuara për Të Lënë Një Përshtypje Të Paharrueshme. 
            Krijoni një identitet vizual të fortë për biznesin tuaj me materialeve profesionale.
          </p>
          <div className={styles.pageButtons}>
            <Link to="/contact">Na kontaktoni</Link>
          </div>
        </div>
      </div>

      <DesignShowcase
        image="/assets/images/menu.webp"
        title="Materiale të Personalizuara për Prezantim Profesional"
        text="Fletushka, Vizitkarta dhe Stickera të Dizajnuara për Të Lënë Një Përshtypje Të Paharrueshme"
        keyOne="Identiteti vizual – Fletushkat, vizitkartat dhe stickerat janë mënyra të shkëlqyera për të krijuar një identitet të fortë vizual për biznesin tuaj."
        keyTwo="Marketing dhe Prezantim – Përdorimi i këtyre materialeve ndihmon në promovimin e shërbimeve ose produkteve tuaj në mënyrë të efektshme."
        keyThree="Krijimtari dhe Personalizim – Çdo material mund të personalizohet për të reflektuar stilin dhe mesazhin e markës tuaj, duke shtuar një prekje unike."
      />

      <DesignShowcase
        reverse="reverse"
        image="/assets/images/totem.webp"
        title="Ngritja e Një Simboli Unik për Kompaninë Tuaj"
        text="Një bashkëpunim mes teknologjisë dhe kreativitetit për të përfaqësuar vlerat tuaja."
        keyOne="Dizajni Inovativ – Krijimi i një totemi 3D që pasqyron kreativitetin dhe modernitetin e markës."
        keyTwo="Ndërtimi dhe Materialet – Përdorimi i materialeve të qëndrueshme dhe teknologjisë së fundit për të realizuar një strukturë të fortë dhe estetike."
        keyThree="Përfaqësimi i Identitetit të Kompanisë – Një simbol vizual që shpreh vlerat dhe misionin e kompanisë përmes dizajnit të saj unik."
      />

      <div className={styles.callUs}>
        <div className="subContainer">
          <h2>Gati për të nisur projektin tuaj?</h2>
          <Link to="/contact">Dërgo email</Link>
        </div>
      </div>

      <FAQ />
    </>
  );
};

export default CustomMaterials;

